import { render } from "./DataOverview.vue?vue&type=template&id=3776ffb4&scoped=true"
import script from "./DataOverview.vue?vue&type=script&lang=js"
export * from "./DataOverview.vue?vue&type=script&lang=js"

import "./DataOverview.vue?vue&type=style&index=0&id=3776ffb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3776ffb4"]])

export default __exports__